export default "__VITE_ASSET__COgDL1sb__"